import { render, staticRenderFns } from "./DlpLoader.vue?vue&type=template&id=cb4f3ae4&"
import script from "./DlpLoader.vue?vue&type=script&lang=js&"
export * from "./DlpLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports